import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=6054d0cb&lang=css"

const __exports__ = script;

export default __exports__